<template>
  <div class="wrapper" v-loading="vLoading">
    <div class="searchBar">
      <el-form :inline="true" :model="searchCondition">
        <el-form-item label="考试名称">
          <el-select
            v-model="searchCondition.examName"
            filterable
            size="small"
            placeholder="搜索考试名称"
          >
            <el-option
              v-for="item in searchMap.examName"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            class="longInput"
            v-model="searchCondition.mobile"
            size="small"
            placeholder="搜索手机号"
          ></el-input> </el-form-item
        ><el-form-item label="下单人">
          <el-input
            class="longInput"
            v-model="searchCondition.userName"
            size="small"
            placeholder="搜索下单人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证">
          <el-input
            class="longInput"
            v-model="searchCondition.idCard"
            size="small"
            placeholder="搜索下单人身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户订单号">
          <el-input
            class="longInput"
            v-model="searchCondition.outTradeNo"
            size="small"
            placeholder="搜索商户订单号"
          ></el-input>
        </el-form-item>

        <el-form-item label="支付方式">
          <el-select
            class="midInput"
            v-model="searchCondition.payType"
            size="small"
            placeholder="支付方式"
          >
            <el-option label="不限支付方式" value=""></el-option>
            <el-option label="支付宝" value="Alipay"></el-option>
            <el-option label="微信" value="WxPay"></el-option>
            <!-- <el-option label="学习币" value="Balance"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="发票状态">
          <el-select
            class="midInput"
            v-model="searchCondition.isInvoice"
            size="small"
            placeholder="发票状态"
          >
            <el-option label="不限发票状态" value=""></el-option>
            <el-option label="已开" :value="1"></el-option>
            <el-option label="待开" :value="2"></el-option>
            <el-option label="冲红" :value="3"></el-option>
            <el-option label="开票中" :value="4"></el-option>
            <el-option label="开票失败" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票是否补开">
          <el-select
            class="midInput"
            v-model="searchCondition.isManual"
            size="small"
            placeholder="发票状态"
          >
            <el-option label="不限发票状态" value=""></el-option>
            <el-option label="系统开" :value="0"></el-option>
            <el-option label="手动开" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付日期">
          <el-date-picker
            class="longInput"
            value-format="yyyy-MM-dd"
            v-model="rangeDate"
            size="small"
            unlink-panels
            type="daterange"
            range-separator="-"
            start-placeholder="支付日期起"
            end-placeholder="支付日期止"
            @change="
              (data) =>
                ([searchCondition.startDate, searchCondition.endDate] =
                  data || ['', ''])
            "
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开票日期">
          <el-date-picker
            class="longInput"
            value-format="yyyy-MM-dd"
            v-model="invoiceRangeDate"
            size="small"
            unlink-panels
            type="daterange"
            range-separator="-"
            start-placeholder="开票日期起"
            end-placeholder="开票日期止"
            @change="
              (data) =>
                ([
                  searchCondition.invoiceStartTime,
                  searchCondition.invoiceEndTime,
                ] = data || ['', ''])
            "
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            @click="searchInvoice"
            size="small"
            type="primary"
            style="width: 75px"
            >查询</el-button
          ><el-button
            @click="resetSearchCondition"
            size="small"
            style="width: 75px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="contentBar">
      <div class="actBar">
        <div>
          <el-dropdown trigger="click">
            <el-button type="primary">导出</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <!-- <el-button
                  type="primary"
                  size="small"
                  @click="exportData(false)"
                  :disabled="selectList.length == 0"
                >
                  导出勾选数据</el-button
                > -->
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button type="primary" size="small" @click="exportData(true)"
                  >导出当前筛选所有数据</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <br />
          <span style="font-size: 16px; margin-left: 20px"
            >已筛选
            <span class="blueFont">{{
              searchCondition.total | moneyFilter
            }}</span>
            项， 总金额：
            <span class="blueFont">{{
              searchMap.sumOrderAmount | moneyFilter
            }}</span>
            元
          </span>

          <!-- <el-button size="small" @click="exportData">导出</el-button> -->
        </div>
        <div>
          <el-button
            size="small"
            type="primary"
            plain
            @click="showCreateInvoice(null, 2)"
            >批量开票</el-button
          >
        </div>
      </div>
      <el-table
        :data="invoiceList"
        @sort-change="sortChange"
        v-loading="tableLoading"
        border
        :header-cell-style="{ background: '#f8f8f9' }"
        @selection-change="
          (e) => {
            selectList = e;
          }
        "
        ref="invoiceTable"
        style="margin-bottom: 10px"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          prop="userName"
          label="下单人"
          sortable
          min-width="90px"
        >
        </el-table-column>
        <el-table-column prop="mobile" label="联系方式" width="120px">
        </el-table-column>

        <el-table-column
          prop="examName"
          min-width="200px"
          label="考试名称"
          sortable
        >
        </el-table-column>
        <el-table-column prop="id" label="订单号" min-width="180px">
        </el-table-column>
        <el-table-column prop="outTradeNo" label="商户订单号" min-width="180px">
        </el-table-column>
        <el-table-column
          prop="payType"
          label="支付方式"
          sortable
          min-width="110px"
        >
        </el-table-column>
        <el-table-column
          prop="orderAmount"
          label="支付金额"
          sortable
          min-width="110px"
        >
        </el-table-column>
        <el-table-column prop="payDate" width="160" label="支付日期" sortable>
        </el-table-column>
        <el-table-column
          prop="isManual"
          width="160"
          label="发票是否补开"
          sortable
        >
        </el-table-column>
        <el-table-column prop="isInvoice" label="发票状态"> </el-table-column>
        <el-table-column
          prop="invoiceTime"
          label="开票时间"
          width="160px"
          sortable
        >
        </el-table-column>
        <el-table-column align="center" width="200">
          <template slot-scope="{ row }">
            <el-button size="mini" @click="getInvoiceDetail(row)"
              >发票信息</el-button
            >
            <el-button
              v-if="row.isInvoice == '未开'"
              size="mini"
              type="danger"
              @click="showCreateInvoice(row.id, 2)"
              >开票</el-button
            >
            <el-button
              v-if="row.isInvoice == '已开'"
              size="mini"
              type="danger"
              @click="showCreateInvoice(row.id, 3)"
              >冲红</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="actBar">
        <div>
          <el-button
            size="small"
            @click="
              invoiceList.forEach((item) => {
                $refs.invoiceTable.toggleRowSelection(item, true);
              })
            "
            >全选</el-button
          >
          <el-button
            size="small"
            @click="$refs.invoiceTable.toggleAllSelection()"
            >反选</el-button
          >
        </div>
        <div>
          <el-pagination
            @current-change="searchInvoice"
            @size-change="searchInvoice"
            :current-page.sync="searchCondition.pageNumber"
            :page-sizes="[10, 30, 100]"
            :page-size.sync="searchCondition.pageSize"
            :total="searchCondition.total"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      title="提示"
      append-to-body
      top="5vh"
      :visible.sync="invoiceDetail.ifShow"
      width="40%"
    >
      <div class="dialogContent">
        <div class="dialogFontBar">
          发票抬头：{{ invoiceDetail.invoiceTitle }}
        </div>
        <div class="dialogFontBar">
          发票类型：{{
            invoiceDetail.invoiceType == 1 ? "个人发票" : "企业发票"
          }}
        </div>
        <div class="dialogFontBar">
          发票内容：{{ invoiceDetail.invoiceBody }}
        </div>
        <div class="dialogFontBar">
          发票金额：{{ invoiceDetail.invoiceAmount }}
        </div>
        <div class="dialogFontBar">
          开票方式：{{ invoiceDetail.einvoice == 0 ? "纸质发票" : "电子发票" }}
        </div>

        <div class="dialogFontBar">联系电话：{{ invoiceDetail.telephone }}</div>
        <div class="dialogFontBar">邮箱：{{ invoiceDetail.email }}</div>
        <div class="dialogFontBar">
          企业税号：{{ invoiceDetail.creditCode }}
        </div>

        <!-- <div class="dialogFontBar">邮寄地址：{{ invoiceDetail.address }}</div> -->
        <!-- <div class="dialogFontBar">收件人：{{ invoiceDetail.consignee }}</div> -->

        <!-- <div class="dialogFontBar">开户行：{{ invoiceDetail.bankName }}</div> -->
        <!-- <div class="dialogFontBar">账户：{{ invoiceDetail.bankNo }}</div> -->
        <div class="dialogFontBar">
          申请时间：{{ invoiceDetail.createTime }}
        </div>
        <div class="dialogFontBar">
          发票种类：{{
            invoiceDetail.invoiceKind == 1 ? "普通发票" : "专用发票"
          }}
        </div>

        <!-- <div class="dialogFontBar">
          快递公司：{{ invoiceDetail.expressCompany }}
        </div> -->
        <div class="dialogFontBar">快递单号：{{ invoiceDetail.expressNo }}</div>
        <div class="dialogFontBar">
          发票状态：{{ invoiceDetail.invoiceStatus == 1 ? "已开" : "未开" }}
        </div>
        <div class="dialogFontBar">发票地址：{{ invoiceDetail.fpUrl }}</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="invoiceDetail.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="invoiceDetail.ifShow = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      append-to-body
      :visible.sync="createInvoiceDetail.ifShow"
      width="40%"
    >
      <div class="dialogContent">
        <div class="dialogFontBar">
          {{
            createInvoiceDetail.isInvoice == 2
              ? "开票"
              : createInvoiceDetail.isInvoice == 3
              ? "冲红"
              : ""
          }}数量：{{ createInvoiceDetail.orderIds.length }}
        </div>
        <div class="dialogFontBar">
          &ensp;&ensp;&ensp;&ensp;备注：<el-input
            style="width: auto; flex: 1"
            type="textarea"
            :rows="5"
            v-model="createInvoiceDetail.remark"
            placeholder="请输入备注说明"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createInvoiceDetail.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="batchCreateInvoice()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  searchInvoiceList,
  invoiceList,
  exportInvoiceRecord,
  batchCreateInvoice,
  batchUpdateInvoice,
} from "@/api/bus";
import Util from "@/libs/util";
export default {
  data() {
    return {
      vLoading: false,
      searchCondition: {
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        isInvoice: "",
        // orderEntity: "",
        examName: "",
        payType: "",
        startDate: "",
        endDate: "",
        invoiceStartTime: "",
        invoiceEndTime: "",
        total: 0,
        sort: "",
        order: "",
        userName: "",
        isManual: "",
        outTradeNo: "",
        idCard: "",
        mobile: "",
      },
      exportMap: { pageSize: 3000, pageNumber: 1 },
      selectList: [],
      invoiceDetail: { ifShow: false },
      createInvoiceDetail: {
        ifShow: false,
        remark: "",
        orderIds: [],
        isInvoice: 0,
      },
      invoiceList: [],
      searchMap: {
        examName: [],
        sumOrderAmount: 0,
      },
      invoiceRangeDate: "",
      rangeDate: "",
      tableLoading: false,
      lastBatchCreateInvoiceTime: null,
    };
  },
  created() {},
  mounted() {
    this.searchInvoice();
  },
  methods: {
    resetSearchCondition() {
      Object.assign(this.searchCondition, this.$options.data().searchCondition);
      this.searchInvoice();
    },
    sortChange({ column, order, prop }) {
      var theOrder = null;
      switch (order) {
        case "ascending":
          theOrder = "asc";
          break;
        case "descending":
          theOrder = "asc";
          break;

        default:
          theOrder = null;
          break;
      }
      Object.assign(this.searchCondition, {
        sort: prop,
        order: theOrder,
        pageNumber: 1,
      });
      this.searchInvoice();
    },
    exportData(ifAll) {
      let postData = {};
      for (let i in this.searchCondition) {
        if (this.searchCondition[i]) {
          postData[i] = this.searchCondition[i];
        }
      }
      if (ifAll) {
        // window.location.href = Util.initUrl(
        //   "/base/common/invoiceRecord",
        //   postData
        // );

        this.vLoading = true;

        if (this.searchCondition.total > this.exportMap.pageSize) {
          const h = this.$createElement;
          let optionList = [];
          for (
            let i = 0;
            i * this.exportMap.pageSize < this.searchCondition.total;
            i++
          ) {
            optionList.push(
              h(
                "option",
                {
                  domProps: {
                    value: i + 1,
                    label: `${i * this.exportMap.pageSize + 1}-${
                      (i + 1) * this.exportMap.pageSize
                    }`,
                  },
                },
                `导出${i * this.exportMap.pageSize + 1}-${
                  (i + 1) * this.exportMap.pageSize
                }条记录`
              )
            );
          }
          this.$msgbox({
            title: "选择导出记录",
            message: h("p", null, [
              h(
                "p",
                null,
                `当前筛选下共有${this.searchCondition.total}条记录，请选择需要导出的条目`
              ),
              h(
                "select",
                {
                  domProps: {
                    value: this.exportMap.pageNumber,
                  },
                  style: "color: teal",
                  on: {
                    change: (e) => {
                      this.$set(this.exportMap, "pageNumber", e.target.value);
                    },
                  },
                },
                optionList
              ),
            ]),
            showCancelButton: true,
            confirmButtonText: "导出",
            cancelButtonText: "取消",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "导出中...";
                exportInvoiceRecord(this.exportMap)
                  .then((data) => {
                    this.$message.success("导出成功!");
                    const pdfUrl = window.URL.createObjectURL(
                      new Blob([data], {
                        type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
                      })
                    );
                    const link = document.createElement("a");
                    link.href = pdfUrl;
                    link.setAttribute(
                      "download",
                      `发票记录${
                        (this.exportMap.pageNumber - 1) *
                          this.exportMap.pageSize +
                        1
                      }-${
                        this.exportMap.pageNumber * this.exportMap.pageSize
                      }.xlsx`
                    );
                    document.body.appendChild(link);
                    link.click();

                    done();
                    instance.confirmButtonLoading = false;
                    this.vLoading = false;
                  })
                  .catch((err) => {
                    done();
                    instance.confirmButtonLoading = false;
                    console.error(err);
                    this.vLoading = false;
                  });
              } else {
                done();
                this.vLoading = false;
              }
            },
          });
        } else {
          if (this.searchCondition.total == 0) {
            this.$message.warning("当前条件下无可导出记录");
            this.vLoading = false;
          } else {
            this.exportMap.pageNumber = 1;
            exportInvoiceRecord(this.exportMap)
              .then((data) => {
                this.$message.success("导出成功!");
                const pdfUrl = window.URL.createObjectURL(
                  new Blob([data], {
                    type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
                  })
                );
                const link = document.createElement("a");
                link.href = pdfUrl;

                link.setAttribute(
                  "download",
                  `发票记录${
                    (this.exportMap.pageNumber - 1) * this.exportMap.pageSize +
                    1
                  }-${this.exportMap.pageNumber * this.exportMap.pageSize}.xlsx`
                );

                document.body.appendChild(link);
                link.click();
                this.vLoading = false;
              })
              .catch((err) => {
                console.error(err);
                this.vLoading = false;
              });
          }
        }
      } else {
        // console.log(this.selectList.map((item) => item.id));
        window.location.href = Util.initUrl("/base/common/invoiceRecord", {
          ids: this.selectList.map((item) => item.id),
        });
      }
      console.log(Util.initUrl("/base/common/invoiceRecord", postData));
    },
    showCreateInvoice(id = null, isInvoice) {
      let ids = null;
      if (id) {
        ids = [id];
      } else {
        ids = this.$refs.invoiceTable.selection.map((item) => item.id);
        if (ids.length < 1) {
          this.$message.warning("请勾选至少一条发票");
          return;
        }
      }
      console.log(ids);
      this.createInvoiceDetail = {
        ifShow: true,
        remark: "",
        orderIds: ids,
        isInvoice,
      };
    },
    batchCreateInvoice() {
      let nowTime = Date.now();
      if (nowTime - this.lastBatchCreateInvoiceTime < 30000) {
        this.$message.warning(
          `请在${parseInt(
            30 - (nowTime - this.lastBatchCreateInvoiceTime) / 1000
          )}秒后进行开票`
        );
        return;
      } else {
        this.lastBatchCreateInvoiceTime = nowTime;
      }
      let postData = {};
      Object.assign(postData, this.createInvoiceDetail);
      if (this.createInvoiceDetail.isInvoice == 2) {
        this.ifRequesting = true;
        batchCreateInvoice(postData).then((data) => {
          this.ifRequesting = false;
          this.$message.success(
            data.info
            // `开票成功，成功${data.data.successSize}条，失败${data.data.failSize}条`
          );
          this.createInvoiceDetail.ifShow = false;
          this.searchInvoice();
        });
      } else if (this.createInvoiceDetail.isInvoice == 3) {
        console.log(postData);
        this.ifRequesting = true;
        batchUpdateInvoice({
          id: postData.orderIds[0],
          isInvoice: postData.isInvoice,
          remark: postData.remark,
        }).then((data) => {
          this.$message.success(
            data.info
            // `冲红成功，成功${data.data.successSize}条，失败${data.data.failSize}条`
          );
          this.ifRequesting = false;
          this.createInvoiceDetail.ifShow = false;
          this.searchInvoice();
        });
      }
    },
    searchInvoice() {
      let postData = {};
      for (let i in this.searchCondition) {
        if (this.searchCondition[i] || this.searchCondition[i] === 0) {
          postData[i] = this.searchCondition[i];
        }
      }
      let exportMap = {};
      Object.assign(exportMap, postData);
      exportMap.pageSize = this.$options.data().exportMap.pageSize;
      exportMap.pageNumber = 1;
      this.exportMap = exportMap;
      this.tableLoading = true;
      searchInvoiceList(postData).then((data) => {
        this.invoiceList = data.data.rows;
        this.searchCondition.total = data.data.total;
        this.searchMap = data.data.map;
        this.tableLoading = false;
      });
    },
    getInvoiceDetail(item) {
      this.tableLoading = true;
      invoiceList(item.id).then((data) => {
        // console.log(data.data[0]);
        let showData = data.data[0] || {};
        showData.ifShow = true;
        this.invoiceDetail = showData;
        // Object.assign(this.invoiceDetail, data.data[0]);
        this.invoiceDetail.ifShow = true;
        this.tableLoading = false;
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .contentBar {
    padding: 15px;
    background: #fff;
    .actBar {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
  }
  .searchBar {
    margin: 20px 0 10px 0;
    background: #fff;
    padding: 20px 20px 10px 20px;
    display: flex;
    justify-content: space-between;
  }
  .midInput {
    width: 160px;
    margin-right: 10px;
  }
  .longInput {
    width: 240px;
    margin-right: 10px;
  }
}
.dialogContent {
  max-height: 60vh;
  overflow-y: scroll;
  .dialogFontBar {
    width: 80%;
    margin: auto;
    font-size: 16px;
    line-height: 28px;
    display: flex;
  }
}
/*定义滚动条高宽及背景
 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
/*定义滚动条轨道
 内阴影+圆角*/
::-webkit-scrollbar-track {
  //   -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
/*定义滑块
 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  //   -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}
/deep/ .el-form-item {
  margin-bottom: 10px;
}
</style>
